import "./Avatar.scss";
import PhotoPicture from "assets/icons/photo.svg";
import PropTypes from "prop-types";
import _ from "lodash";
const Avatar = ({
  id,
  initials,
  replace,
  size,
  background,
  onClick,
  isRounded,
  isBordered,
  avatarBackgroundColor,
  placeholderIcon,
}) => {
  const isMiniAvatar = size === "x-small";
  const miniAvatarStyle = {
    margin: "4px 0 0 0",
    height: "20px",
    width: "20px",
  };
  return (
    <>
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundColor: avatarBackgroundColor,
          borderRadius: isRounded ? "100%" : "0",
          border: isBordered ? "3px solid #42405B" : null,
        }}
        className={`box box-${size} `}
        onClick={onClick}
        id={`avatar-${id}`}
      >
        {initials && !background && (
          <div className="display_initals">
            <p>{initials}</p>
          </div>
        )}
        {(!background || background === "") && !initials && (
          <div
            className={`pic pic-${size}`}
            style={{
              backgroundImage: `url(${placeholderIcon || PhotoPicture})`,
              backgroundSize: replace ? "cover" : "contain",
              backgroundRepeat: "no-repeat",
              ...(placeholderIcon && { backgroundPosition: "center" }),
              ...(isMiniAvatar && miniAvatarStyle),
            }}
          />
        )}
      </div>
    </>
  );
};

Avatar.propTypes = {
  id: PropTypes.string,
  initials: PropTypes.string,
  replace: PropTypes.bool,
  size: PropTypes.string,
  background: PropTypes.string,
  onClick: PropTypes.func,
  isRounded: PropTypes.bool,
  isBordered: PropTypes.bool,
  avatarBackgroundColor: PropTypes.string,
  // Image shown while the avatar is empty. Defaults to the photo icon.
  placeholderIcon: PropTypes.string,
};

Avatar.defaultProps = {
  initials: "",
  replace: false,
  size: "",
  background: "",
  onClick: _.noop,
  isRounded: true,
};

export default Avatar;
